import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LeftPane from '../../components/LeftPane.js';
import Header from '../../components/Header.js';
import { MDBIcon } from 'mdb-react-ui-kit';
import { createwhatsAppTemplates, getwhatsAppTemplatesById, submitTemplateToMeta } from '../../services/apiServices.js';
import MediaUploader from '../components/MediaUploader.js';
import '../styles/whatsapp-create-template.css';

const CreateWhatsAppTemplate = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [loadingTemplate, setLoadingTemplate] = useState(false);
    const [templateinfo, setTemplateInfo] = useState(null);

    // Image header state
    const [headerImagePreview, setHeaderImagePreview] = useState('');
    const [headerImageUrl, setHeaderImageUrl] = useState('');
    const [imageInputMode, setImageInputMode] = useState('upload');
    const [imageUrlInput, setImageUrlInput] = useState('');
    const [imageUrlVars, setImageUrlVars] = useState([]);
    const [imageUrlSampleInput, setImageUrlSampleInput] = useState('');

    // Template form state
    const [templateData, setTemplateData] = useState({
        name: '', category: 'UTILITY', language: 'en',
        components: {
            header: { format: 'NONE', text: '', mediaUrl: '', mediaHandle: '', isDynamic: false, examples: [] },
            body: { text: '', examples: [] },
            footer: { text: '' },
            buttons: []
        }
    });

    const [buttonType, setButtonType] = useState('QUICK_REPLY');
    const [buttonText, setButtonText] = useState('');
    const [buttonUrl, setButtonUrl] = useState('');
    const [buttonPhone, setButtonPhone] = useState('');
    const [bodyVariables, setBodyVariables] = useState([]);
    const [headerVariables, setHeaderVariables] = useState([]);
    const [nextVariableNumber, setNextVariableNumber] = useState(1);

    const transformBackendTemplate = (t) => {
        const c = t.components || {};
        return {
            name: t.name || '', category: t.category || 'UTILITY', language: t.language || 'en',
            components: {
                header: {
                    format: c.header?.format || 'NONE',
                    text: c.header?.text || '',
                    mediaUrl: c.header?.mediaUrl || '',
                    mediaHandle: c.header?.mediaHandle || '',
                    isDynamic: c.header?.isDynamic || false,
                    examples: c.header?.examples || []
                },
                body: { text: c.body?.text || '', examples: c.body?.examples || [] },
                footer: { text: c.footer?.text || '' },
                buttons: c.buttons || []
            }
        };
    };

    useEffect(() => {
        const fetchTemplate = async () => {
            if (!location.state?.id) return;
            try {
                setLoadingTemplate(true);
                const resp = await getwhatsAppTemplatesById(location.state.id);
                if (!resp || resp === 'false') return;
                const json = await resp.json();
                console.log(json.template, 'json.template');

                if (json.success && json.template) {
                    const transformed = transformBackendTemplate(json.template);
                    setTemplateData(transformed);
                    setTemplateInfo(json.template);

                    if (transformed.components.header.format === 'IMAGE' && transformed.components.header.mediaUrl) {
                        const savedUrl = transformed.components.header.mediaUrl;
                        setImageUrlInput(savedUrl);
                        setImageInputMode('url');
                        setHeaderImageUrl(savedUrl);
                        if (transformed.components.header.isDynamic) {
                            const sample = transformed.components.header.examples?.[0] || '';
                            setImageUrlSampleInput(sample);
                            setHeaderImagePreview(sample);
                            setImageUrlVars([{ id: 1, example: sample }]);
                        } else {
                            setHeaderImagePreview(savedUrl);
                        }
                    }
                    const allText = [transformed.components.header.text, transformed.components.body.text].join(' ');
                    const matches = [...allText.matchAll(/\{\{(\d+)\}\}/g)];
                    setNextVariableNumber(Math.max(...matches.map(m => parseInt(m[1])), 0) + 1);
                }
            } catch (err) { console.error('Error fetching template:', err); }
            finally { setLoadingTemplate(false); }
        };
        fetchTemplate();
    }, [location.state?.id]);

    useEffect(() => {
        const matches = [...templateData.components.body.text.matchAll(/\{\{(\d+)\}\}/g)];
        setBodyVariables(matches.map(m => ({
            id: parseInt(m[1]), placeholder: `{{${m[1]}}}`,
            example: templateData.components.body.examples[parseInt(m[1]) - 1] || ''
        })));
    }, [templateData.components.body.text, templateData.components.body.examples]);

    useEffect(() => {
        const matches = [...(templateData.components.header.text || '').matchAll(/\{\{(\d+)\}\}/g)];
        setHeaderVariables(matches.map(m => ({
            id: parseInt(m[1]), placeholder: `{{${m[1]}}}`,
            example: templateData.components.header.examples[parseInt(m[1]) - 1] || ''
        })));
    }, [templateData.components.header.text, templateData.components.header.examples]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [section, field] = name.split('.');
            setTemplateData(prev => ({ ...prev, components: { ...prev.components, [section]: { ...prev.components[section], [field]: value } } }));
        } else {
            setTemplateData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleHeaderFormatChange = (e) => {
        const format = e.target.value;
        if (format !== 'IMAGE') {
            setHeaderImagePreview(''); setHeaderImageUrl('');
            setImageUrlInput(''); setImageInputMode('upload');
            setImageUrlVars([]); setImageUrlSampleInput('');
        }
        setTemplateData(prev => ({
            ...prev,
            components: {
                ...prev.components,
                header: {
                    format,
                    text: format === 'NONE' ? '' : prev.components.header.text,
                    mediaUrl: format === 'IMAGE' ? prev.components.header.mediaUrl : '',
                    mediaHandle: format === 'IMAGE' ? prev.components.header.mediaHandle : '',
                    isDynamic: format === 'IMAGE' ? prev.components.header.isDynamic : false,
                    examples: []
                }
            }
        }));
    };

    const removeHeaderImage = () => {
        setHeaderImagePreview(''); setHeaderImageUrl('');
        setImageUrlInput(''); setImageUrlVars([]); setImageUrlSampleInput('');
        setTemplateData(prev => ({
            ...prev,
            components: { ...prev.components, header: { ...prev.components.header, mediaUrl: '', mediaHandle: '', isDynamic: false, examples: [] } }
        }));
    };

    // Called by MediaUploader when S3 upload completes
    const handleUploadComplete = (s3Url) => {
        console.log(s3Url, 'gsdvg');

        setHeaderImagePreview(s3Url);
        setHeaderImageUrl(s3Url);
        setTemplateData(prev => ({
            ...prev,
            components: { ...prev.components, header: { ...prev.components.header, mediaUrl: s3Url, isDynamic: false, examples: [] } }
        }));
    };

    // URL mode helpers
    const parseImageUrlVars = (urlTemplate) => {
        const matches = [...urlTemplate.matchAll(/\{\{(\d+)\}\}/g)];
        const ids = [...new Set(matches.map(m => parseInt(m[1])))].sort((a, b) => a - b);
        return ids.map(id => ({ id, example: imageUrlVars.find(v => v.id === id)?.example || '' }));
    };

    const handleImageUrlInputChange = (e) => {
        const val = e.target.value;
        setImageUrlInput(val);
        setImageUrlVars(parseImageUrlVars(val));
        if (!val.trim()) { setHeaderImagePreview(''); setHeaderImageUrl(''); }
    };

    const handleImageUrlSampleChange = (e) => {
        setImageUrlSampleInput(e.target.value);
        setHeaderImagePreview(e.target.value);
    };

    const handleImageUrlApply = () => {
        const urlTemplate = imageUrlInput.trim();
        if (!urlTemplate) return;
        const isDynamic = /\{\{\d+\}\}/.test(urlTemplate);
        if (isDynamic) {
            if (!imageUrlSampleInput.trim()) { alert('Please enter a sample image URL so Meta can review the template.'); return; }
            try { new URL(imageUrlSampleInput.trim()); } catch { alert('Sample URL must be a valid URL (include https://).'); return; }
            setHeaderImagePreview(imageUrlSampleInput.trim());
            setHeaderImageUrl(urlTemplate);
            setTemplateData(prev => ({
                ...prev,
                components: { ...prev.components, header: { ...prev.components.header, mediaUrl: urlTemplate, isDynamic: true, examples: [imageUrlSampleInput.trim()] } }
            }));
        } else {
            try { new URL(urlTemplate); } catch { alert('Please enter a valid URL (include https://).'); return; }
            setHeaderImagePreview(urlTemplate);
            setHeaderImageUrl(urlTemplate);
            setTemplateData(prev => ({
                ...prev,
                components: { ...prev.components, header: { ...prev.components.header, mediaUrl: urlTemplate, isDynamic: false, examples: [] } }
            }));
        }
    };

    const handleButtonTypeChange = (e) => {
        const type = e.target.value; setButtonType(type);
        if (type !== 'URL') setButtonUrl('');
        if (type !== 'PHONE_NUMBER') setButtonPhone('');
    };

    const addVariableToText = (fieldType, text) => {
        const ph = `{{${nextVariableNumber}}}`;
        if (fieldType === 'header') {
            setTemplateData(prev => ({ ...prev, components: { ...prev.components, header: { ...prev.components.header, text: text + ph, examples: [...prev.components.header.examples, ''] } } }));
        } else {
            setTemplateData(prev => ({ ...prev, components: { ...prev.components, body: { ...prev.components.body, text: text + ph, examples: [...prev.components.body.examples, ''] } } }));
        }
        setNextVariableNumber(n => n + 1);
    };

    const addVariableToBody = () => addVariableToText('body', templateData.components.body.text);
    const addVariableToHeader = () => addVariableToText('header', templateData.components.header.text);

    const handleBodyVariableExampleChange = (varId, value) => {
        const idx = varId - 1;
        const examples = [...templateData.components.body.examples];
        while (examples.length <= idx) examples.push('');
        examples[idx] = value;
        setTemplateData(prev => ({ ...prev, components: { ...prev.components, body: { ...prev.components.body, examples } } }));
    };

    const handleHeaderVariableExampleChange = (varId, value) => {
        const idx = varId - 1;
        const examples = [...templateData.components.header.examples];
        while (examples.length <= idx) examples.push('');
        examples[idx] = value;
        setTemplateData(prev => ({ ...prev, components: { ...prev.components, header: { ...prev.components.header, examples } } }));
    };

    const getVariableExample = (varId, type) => {
        if (type === 'body') return templateData.components.body.examples[varId - 1] || '';
        if (type === 'header') return templateData.components.header.examples[varId - 1] || '';
        return '';
    };

    const addButton = () => {
        if (!buttonText.trim() || templateData.components.buttons.length >= 10) return;
        let finalUrl = buttonUrl;
        if (buttonType === 'URL' && finalUrl && !finalUrl.startsWith('http')) finalUrl = 'https://' + finalUrl;
        setTemplateData(prev => ({
            ...prev,
            components: {
                ...prev.components,
                buttons: [...prev.components.buttons, {
                    type: buttonType, text: buttonText,
                    ...(buttonType === 'URL' && { url: finalUrl }),
                    ...(buttonType === 'PHONE_NUMBER' && { phoneNumber: buttonPhone || '+1234567890' })
                }]
            }
        }));
        setButtonText(''); setButtonUrl(''); setButtonPhone('');
    };

    const removeButton = (index) => {
        setTemplateData(prev => ({ ...prev, components: { ...prev.components, buttons: prev.components.buttons.filter((_, i) => i !== index) } }));
    };

    const handleSubmit = async (action) => {
        if (action === 'submit' && templateData.components.header.format === 'IMAGE' && !headerImageUrl) {
            alert('Please upload or enter a header image before submitting.'); return;
        }
        try {
            setLoading(true);
            const loggedUserInfo = JSON.parse(localStorage.getItem('loggedUserInfo')) || {};
            const submissionData = {
                name: templateData.name, category: templateData.category, language: templateData.language,
                components: {
                    header: {
                        format: templateData.components.header.format,
                        text: templateData.components.header.text || '',
                        mediaUrl: templateData.components.header.mediaUrl || '',
                        mediaHandle: templateData.components.header.mediaHandle || '',
                        isDynamic: templateData.components.header.isDynamic || false,
                        examples: templateData.components.header.examples || []
                    },
                    body: { text: templateData.components.body.text, examples: templateData.components.body.examples || [] },
                    ...(templateData.components.footer.text && { footer: { text: templateData.components.footer.text } }),
                    ...(templateData.components.buttons.length > 0 && { buttons: templateData.components.buttons })
                },
                gymid: loggedUserInfo.gymid || '', createdBy: loggedUserInfo._id || null,
                status: action === 'submit' ? 'pending' : 'draft',
                _id: templateinfo?._id || -1
            };
            const apiCall = action === 'submit' ? submitTemplateToMeta : createwhatsAppTemplates;
            const response = await apiCall(submissionData);
            if (!response || response === 'false') { alert('Request failed'); return; }
            const recinfo = await response.json();
            if (recinfo.success) {
                alert(action === 'submit' ? 'Template submitted for approval!' : 'Template saved as draft!');
                navigate('/whatsapp/templates');
            } else {
                alert(recinfo.message || 'Operation failed');
            }
        } catch (error) {
            console.error('Error saving template:', error);
            alert(error.message || 'Failed to save template');
        } finally { setLoading(false); }
    };

    const formatPreviewText = (text, examples = []) => {
        if (!text) return '';
        return text
            .replace(/\{\{(\d+)\}\}/g, (_, n) => {
                const ex = examples[parseInt(n) - 1] || `{{${n}}}`;
                return `<span class="meta-preview-variable">${ex}</span>`;
            })
            .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
            .replace(/_(.*?)_/g, '<em>$1</em>')
            .replace(/~(.*?)~/g, '<del>$1</del>')
            .replace(/```(.*?)```/gs, '<code>$1</code>')
            .replace(/\n/g, '<br />');
    };

    if (loadingTemplate) {
        return (
            <div className="gym-container"><LeftPane isactive="16" /><Header />
                <div className="gym-main gym-main-div rightContent">
                    <div className="meta-create-template">
                        <div className="meta-loading-state">
                            <div className="spinner-border text-success" role="status" />
                            <p className="meta-loading-text">Loading template...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const headerFormat = templateData.components.header.format;

    return (
        <div className="gym-container">
            <LeftPane isactive="16" /><Header />
            <div className="gym-main gym-main-div rightContent">
                <div className="meta-create-template">

                    {/* Page Header */}
                    <div className="meta-template-header">
                        <div className="meta-header-left">
                            <button className="meta-back-button" onClick={() => navigate('/whatsapp/templates')}>
                                <MDBIcon icon="arrow-left" /> Back
                            </button>
                            <div className="meta-header-divider" />
                            <div>
                                <h3 className="meta-template-title">{location.state?.id ? 'Edit Template' : 'Create New Template'}</h3>
                                <p className="meta-template-subtitle">Design your WhatsApp Business message template</p>
                            </div>
                        </div>
                        <div className="meta-form-actions">
                            <button type="button" onClick={() => handleSubmit('draft')} disabled={loading} className="meta-action-button meta-action-draft">
                                <MDBIcon icon="save" /> Save as Draft
                            </button>
                            <button type="button" onClick={() => handleSubmit('submit')}
                                disabled={loading || !templateData.name || !templateData.components.body.text}
                                className="meta-action-button meta-action-submit">
                                {loading ? <><span className="spinner-border spinner-border-sm" role="status" /> Submitting...</> : <><MDBIcon icon="paper-plane" /> Save &amp; Submit</>}
                            </button>
                        </div>
                    </div>

                    <div className="meta-template-content">

                        {/* LEFT: Form */}
                        <div className="meta-template-form">

                            {templateinfo?.metaSubmissionError && (
                                <div className="meta-form-section">
                                    <div className="meta-alert meta-alert-danger">
                                        <MDBIcon icon="exclamation-triangle" />
                                        <div>
                                            <strong>{templateinfo.metaSubmissionError.error_title || 'Meta Submission Error'}</strong>
                                            <div>{templateinfo.metaSubmissionError.error_message || templateinfo.metaSubmissionError.message}</div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Section 1: Basic Info */}
                            <div className="meta-form-section">
                                <div className="meta-section-header">
                                    <span className="meta-section-number">1</span>
                                    <h4 className="meta-section-title">Basic Information</h4>
                                </div>
                                <div className="meta-form-group" style={{ marginTop: 16 }}>
                                    <label className="meta-label">Template Name *</label>
                                    <input type="text" name="name" value={templateData.name} onChange={handleChange}
                                        className="meta-input" placeholder="e.g. order_confirmation_v1" required maxLength="512" />
                                    <div className="meta-hint">Use lowercase letters and underscores only.</div>
                                </div>
                                <div className="meta-form-row">
                                    <div className="meta-form-group">
                                        <label className="meta-label">Category *</label>
                                        <div className="meta-category-options">
                                            {['UTILITY', 'MARKETING', 'AUTHENTICATION'].map(cat => (
                                                <label key={cat} className="meta-category-option">
                                                    <input type="radio" name="category" value={cat} checked={templateData.category === cat} onChange={handleChange} />
                                                    <span className="meta-category-label">{cat.charAt(0) + cat.slice(1).toLowerCase()}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="meta-form-group">
                                        <label className="meta-label">Language *</label>
                                        <select name="language" value={templateData.language} onChange={handleChange} className="meta-select" required>
                                            <option value="en">English (en)</option>
                                            <option value="en_US">English (US)</option>
                                            <option value="en_GB">English (UK)</option>
                                            <option value="es">Spanish</option>
                                            <option value="fr">French</option>
                                            <option value="de">German</option>
                                            <option value="hi">Hindi</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* Section 2: Header */}
                            <div className="meta-form-section">
                                <div className="meta-section-header">
                                    <span className="meta-section-number">2</span>
                                    <h4 className="meta-section-title">Header</h4>
                                    <span className="meta-section-badge">Optional</span>
                                </div>
                                <div className="meta-hint">{`Add a title or image. Text headers support {{1}} variables.`}</div>

                                {/* Format selector */}
                                <div className="meta-form-group" style={{ marginTop: 14 }}>
                                    <div className="meta-header-options">
                                        {[
                                            { value: 'NONE', label: 'None', icon: 'ban' },
                                            { value: 'TEXT', label: 'Text', icon: 'font' },
                                            { value: 'IMAGE', label: 'Image', icon: 'image' }
                                        ].map(opt => (
                                            <label key={opt.value} className="meta-header-option">
                                                <input type="radio" name="header.format" value={opt.value}
                                                    checked={headerFormat === opt.value} onChange={handleHeaderFormatChange} />
                                                <span className="meta-header-option-content">
                                                    <MDBIcon icon={opt.icon} className="meta-header-icon" />
                                                    <span>{opt.label}</span>
                                                </span>
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                {/* TEXT header */}
                                {headerFormat === 'TEXT' && (
                                    <div className="meta-form-group">
                                        <div className="meta-textarea-container">
                                            <textarea name="header.text" value={templateData.components.header.text}
                                                onChange={handleChange} className="meta-textarea"
                                                placeholder="Enter header text..." rows="2" maxLength="60" />
                                            <div className="meta-textarea-toolbar">
                                                <button type="button" className="meta-toolbar-button" onClick={addVariableToHeader}>
                                                    <MDBIcon icon="code" /> Add Variable
                                                </button>
                                                <span className="meta-character-count">{templateData.components.header.text.length}/60</span>
                                            </div>
                                        </div>
                                        {headerVariables.length > 0 && (
                                            <div className="meta-variables-section">
                                                <h4 className="meta-variables-title"><MDBIcon icon="tag" className="me-1" /> Header Variables</h4>
                                                <div className="meta-variables-list">
                                                    {headerVariables.map(v => (
                                                        <div key={v.id} className="meta-variable-item">
                                                            <div className="meta-variable-header"><span className="meta-variable-placeholder">{v.placeholder}</span></div>
                                                            <input type="text" value={getVariableExample(v.id, 'header')}
                                                                onChange={e => handleHeaderVariableExampleChange(v.id, e.target.value)}
                                                                className="meta-input" placeholder={`Example for ${v.placeholder}`} />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* IMAGE header */}
                                {headerFormat === 'IMAGE' && (
                                    <div className="meta-form-group meta-image-upload-group">
                                        <div className="meta-image-upload-info">
                                            <MDBIcon fas icon="info-circle" className="meta-image-info-icon" />
                                            <span>Accepted: JPEG · PNG &nbsp;·&nbsp; Max: 5 MB &nbsp;·&nbsp; Recommended: 800×418 px (1.91:1)</span>
                                        </div>

                                        {/* Upload / URL toggle */}
                                        <div className="meta-image-mode-toggle">
                                            <button type="button"
                                                className={`meta-image-mode-btn ${imageInputMode === 'upload' ? 'meta-image-mode-active' : ''}`}
                                                onClick={() => { setImageInputMode('upload'); removeHeaderImage(); }}>
                                                <MDBIcon fas icon="upload" /> Upload File
                                            </button>
                                            <button type="button"
                                                className={`meta-image-mode-btn ${imageInputMode === 'url' ? 'meta-image-mode-active' : ''}`}
                                                onClick={() => { setImageInputMode('url'); removeHeaderImage(); }}>
                                                <MDBIcon fas icon="link" /> Enter URL
                                            </button>
                                        </div>

                                        {/* UPLOAD mode — MediaUploader component */}
                                        {imageInputMode === 'upload' && (
                                            <>
                                                {!headerImageUrl ? (
                                                    <MediaUploader onUploadComplete={handleUploadComplete} />
                                                ) : (
                                                    <div className="meta-image-preview-card">
                                                        <img src={headerImagePreview} alt="Header preview" className="meta-image-preview-img" />
                                                        <div className="meta-image-preview-overlay">
                                                            <div className="meta-image-preview-actions">
                                                                <button type="button" className="meta-image-remove-btn" onClick={removeHeaderImage}>
                                                                    <MDBIcon fas icon="trash" /> Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="meta-image-file-info">
                                                            <MDBIcon fas icon="check-circle" className="meta-image-file-ok" />
                                                            <span className="meta-image-url-applied">Uploaded to S3 ✓</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {/* URL mode */}
                                        {imageInputMode === 'url' && (
                                            <div className="meta-image-url-input-group">
                                                <label className="meta-label" style={{ marginBottom: 6 }}>
                                                    Image URL
                                                    <span className="meta-hint" style={{ fontWeight: 400, marginLeft: 8 }}>
                                                        Use <code className="meta-code-inline">{'{{1}}'}</code> for a dynamic URL (e.g. per-member QR code)
                                                    </span>
                                                </label>
                                                <div className="meta-image-url-row">
                                                    <input type="text"
                                                        className="meta-input meta-image-url-field"
                                                        placeholder="https://cdn.example.com/qr/{{1}}.png  or  https://example.com/banner.jpg"
                                                        value={imageUrlInput}
                                                        onChange={handleImageUrlInputChange}
                                                        onKeyDown={e => e.key === 'Enter' && handleImageUrlApply()}
                                                    />
                                                    <button type="button" className="meta-image-url-apply-btn"
                                                        onClick={handleImageUrlApply}
                                                        disabled={!imageUrlInput.trim() || (imageUrlVars.length > 0 && !imageUrlSampleInput.trim())}>
                                                        <MDBIcon fas icon="check" /> Apply
                                                    </button>
                                                </div>

                                                {/* Variable detected → sample box */}
                                                {imageUrlVars.length > 0 && (
                                                    <div className="meta-image-var-sample-box">
                                                        <div className="meta-image-var-sample-header">
                                                            <MDBIcon fas icon="flask" className="meta-image-var-sample-icon" />
                                                            <div>
                                                                <div className="meta-image-var-sample-title">Variable detected — provide a sample URL</div>
                                                                <div className="meta-image-var-sample-sub">
                                                                    Meta requires a real image example to review your template.
                                                                    This sample is only used for approval — at send time{' '}
                                                                    <code className="meta-code-inline">{'{{1}}'}</code> will be replaced with each member's actual URL.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {imageUrlVars.map(v => (
                                                            <div key={v.id} className="meta-image-var-sample-row">
                                                                <span className="meta-variable-placeholder">{`{{${v.id}}}`}</span>
                                                                <input type="url" className="meta-input"
                                                                    placeholder={`Sample URL for {{${v.id}}} e.g. https://cdn.example.com/qr/member_001.png`}
                                                                    value={imageUrlSampleInput}
                                                                    onChange={handleImageUrlSampleChange}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* Preview after apply */}
                                                {headerImageUrl && (
                                                    <div className="meta-image-preview-card" style={{ marginTop: 12 }}>
                                                        {headerImagePreview && (
                                                            <img src={headerImagePreview} alt="Sample preview"
                                                                className="meta-image-preview-img"
                                                                onError={e => { e.target.style.display = 'none'; }} />
                                                        )}
                                                        <div className="meta-image-preview-overlay">
                                                            <div className="meta-image-preview-actions">
                                                                <button type="button" className="meta-image-remove-btn" onClick={removeHeaderImage}>
                                                                    <MDBIcon fas icon="trash" /> Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="meta-image-file-info">
                                                            <MDBIcon fas icon="check-circle" className="meta-image-file-ok" />
                                                            {templateData.components.header.isDynamic
                                                                ? <>
                                                                    <span className="meta-image-url-applied">Dynamic URL applied</span>
                                                                    <span className="meta-image-dynamic-chip">
                                                                        <MDBIcon fas icon="qrcode" /> {'{{1}}'} per member
                                                                    </span>
                                                                </>
                                                                : <span className="meta-image-url-applied">URL applied</span>
                                                            }
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Section 3: Body */}
                            <div className="meta-form-section">
                                <div className="meta-section-header">
                                    <span className="meta-section-number">3</span>
                                    <h4 className="meta-section-title">Body</h4>
                                    <span className="meta-section-badge" style={{ background: '#fef9c3', color: '#92400e' }}>Required</span>
                                </div>
                                <div className="meta-hint">{`Write your message. Use {{1}}, {{2}}... for personalized values.`}</div>
                                <div className="meta-form-group" style={{ marginTop: 14 }}>
                                    <div className="meta-textarea-container">
                                        <textarea name="body.text" value={templateData.components.body.text}
                                            onChange={handleChange} className="meta-textarea"
                                            placeholder="Hi {{1}}, your order #{{2}} is confirmed."
                                            rows="5" required maxLength="1024" />
                                        <div className="meta-textarea-toolbar">
                                            <button type="button" className="meta-toolbar-button" onClick={addVariableToBody}>
                                                <MDBIcon icon="code" /> Add Variable
                                            </button>
                                            <span className="meta-character-count">{templateData.components.body.text.length}/1024</span>
                                        </div>
                                    </div>
                                </div>
                                {bodyVariables.length > 0 && (
                                    <div className="meta-variables-section">
                                        <h4 className="meta-variables-title"><MDBIcon icon="tag" className="me-1" /> Body Variables</h4>
                                        <div className="meta-variables-list">
                                            {bodyVariables.map(v => (
                                                <div key={v.id} className="meta-variable-item">
                                                    <div className="meta-variable-header"><span className="meta-variable-placeholder">{v.placeholder}</span></div>
                                                    <input type="text" value={getVariableExample(v.id, 'body')}
                                                        onChange={e => handleBodyVariableExampleChange(v.id, e.target.value)}
                                                        className="meta-input" placeholder={`Example for ${v.placeholder}`} />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Section 4: Footer */}
                            <div className="meta-form-section">
                                <div className="meta-section-header">
                                    <span className="meta-section-number">4</span>
                                    <h4 className="meta-section-title">Footer</h4>
                                    <span className="meta-section-badge">Optional</span>
                                </div>
                                <div className="meta-hint">Add disclaimers or unsubscribe info.</div>
                                <div className="meta-form-group" style={{ marginTop: 14 }}>
                                    <textarea name="footer.text" value={templateData.components.footer.text}
                                        onChange={handleChange} className="meta-textarea"
                                        placeholder="e.g. Reply STOP to unsubscribe" rows="2" maxLength="60" />
                                    <div className="meta-textarea-toolbar">
                                        <span />
                                        <span className="meta-character-count">{templateData.components.footer.text.length}/60</span>
                                    </div>
                                </div>
                            </div>

                            {/* Section 5: Buttons */}
                            <div className="meta-form-section">
                                <div className="meta-section-header">
                                    <span className="meta-section-number">5</span>
                                    <h4 className="meta-section-title">Buttons</h4>
                                    <span className="meta-section-badge">Optional</span>
                                </div>
                                <div className="meta-hint">Add quick replies, URL buttons, or phone number buttons.</div>
                                <div className="meta-buttons-form">
                                    <div className="meta-button-inputs" style={{ marginTop: 14 }}>
                                        <select value={buttonType} onChange={handleButtonTypeChange} className="meta-select">
                                            <option value="QUICK_REPLY">Quick Reply</option>
                                            <option value="URL">Website URL</option>
                                            <option value="PHONE_NUMBER">Phone Number</option>
                                        </select>
                                        <input type="text" value={buttonText} onChange={e => setButtonText(e.target.value)}
                                            className="meta-input" placeholder="Button label (max 25 chars)" maxLength="25" />
                                        {buttonType === 'URL' && (
                                            <input type="url" value={buttonUrl} onChange={e => setButtonUrl(e.target.value)}
                                                className="meta-input" placeholder="https://example.com" />
                                        )}
                                        {buttonType === 'PHONE_NUMBER' && (
                                            <input type="tel" value={buttonPhone} onChange={e => setButtonPhone(e.target.value)}
                                                className="meta-input" placeholder="+1234567890" />
                                        )}
                                        <button type="button" onClick={addButton} className="meta-add-button"
                                            disabled={!buttonText.trim() || templateData.components.buttons.length >= 10}>
                                            <MDBIcon icon="plus" /> Add Button
                                        </button>
                                    </div>
                                    {templateData.components.buttons.length >= 10 && (
                                        <div className="meta-alert meta-alert-warning">
                                            <MDBIcon icon="exclamation-triangle" /> Maximum 10 buttons reached
                                        </div>
                                    )}
                                </div>
                                {templateData.components.buttons.length > 0 && (
                                    <div className="meta-buttons-list">
                                        <h4 className="meta-buttons-title">Added Buttons ({templateData.components.buttons.length}/10)</h4>
                                        {templateData.components.buttons.map((btn, i) => (
                                            <div key={i} className="meta-button-item">
                                                <div className="meta-button-info">
                                                    <div className="meta-button-type">
                                                        <MDBIcon icon={btn.type === 'QUICK_REPLY' ? 'reply' : btn.type === 'URL' ? 'link' : 'phone-alt'} className="meta-button-icon" />
                                                        <span>{btn.type.replace('_', ' ')}</span>
                                                    </div>
                                                    <div className="meta-button-text">{btn.text}</div>
                                                    {btn.url && <div className="meta-button-url">{btn.url}</div>}
                                                    {btn.phoneNumber && <div className="meta-button-phone">{btn.phoneNumber}</div>}
                                                </div>
                                                <button type="button" onClick={() => removeButton(i)} className="meta-button-remove">
                                                    <MDBIcon icon="times" />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* RIGHT: Live Preview */}
                        <div className="meta-template-preview">
                            <div className="meta-preview-header">
                                <h4 className="meta-preview-title">Live Preview</h4>
                                <span className="meta-preview-badge"><MDBIcon fas icon="mobile-alt" /> WhatsApp</span>
                            </div>
                            <div className="meta-mobile-preview">
                                <div className="meta-mobile-frame">
                                    <div className="meta-mobile-status-bar">
                                        <span>9:41</span>
                                        <div className="meta-mobile-status-icons">
                                            <span className="meta-mobile-signal" />
                                            <span className="meta-mobile-wifi" />
                                            <span className="meta-mobile-battery" />
                                        </div>
                                    </div>
                                    <div className="meta-mobile-header">
                                        <div className="meta-mobile-back"><MDBIcon icon="chevron-left" /></div>
                                        <div className="meta-mobile-contact">
                                            <div className="meta-mobile-avatar"><MDBIcon icon="building" /></div>
                                            <div className="meta-mobile-contact-name">Easymembr <span className="meta-mobile-verified">✓</span></div>
                                        </div>
                                        <div className="meta-mobile-actions">
                                            <MDBIcon icon="video" /><MDBIcon icon="phone-alt" /><MDBIcon icon="ellipsis-v" />
                                        </div>
                                    </div>
                                    <div className="meta-mobile-chat">
                                        <div className="meta-mobile-security-message">
                                            <div className="meta-mobile-security-icon"><MDBIcon icon="lock" /></div>
                                            <div>
                                                <div className="meta-mobile-security-title">End-to-end encrypted</div>
                                                <div className="meta-mobile-security-subtitle">Messages and calls are secured.</div>
                                            </div>
                                        </div>
                                        <div className="meta-mobile-template-message">

                                            {/* IMAGE header preview */}
                                            {headerFormat === 'IMAGE' && (
                                                <div className="meta-mobile-template-header meta-mobile-template-image-header">
                                                    {headerImagePreview
                                                        ? <>
                                                            <img src={headerImagePreview} alt="Header" className="meta-mobile-preview-image" />
                                                            {templateData.components.header.isDynamic && (
                                                                <div className="meta-mobile-dynamic-badge">
                                                                    <MDBIcon fas icon="qrcode" /> {'{{1}}'} per member
                                                                </div>
                                                            )}
                                                        </>
                                                        : <div className="meta-mobile-image-placeholder">
                                                            {imageUrlVars.length > 0
                                                                ? <><MDBIcon fas icon="qrcode" /><span>{'{{1}}'} — unique per member</span></>
                                                                : <><MDBIcon fas icon="image" /><span>Image preview</span></>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            )}

                                            {/* TEXT header preview */}
                                            {headerFormat === 'TEXT' && templateData.components.header.text && (
                                                <div className="meta-mobile-template-header">
                                                    <div className="meta-mobile-template-text-header"
                                                        dangerouslySetInnerHTML={{ __html: formatPreviewText(templateData.components.header.text, templateData.components.header.examples) }}
                                                    />
                                                </div>
                                            )}

                                            {/* Body */}
                                            <div className="meta-mobile-template-body">
                                                <div className="meta-mobile-template-text"
                                                    dangerouslySetInnerHTML={{ __html: formatPreviewText(templateData.components.body.text, templateData.components.body.examples) || 'Your message will appear here...' }}
                                                />
                                            </div>

                                            {/* Footer */}
                                            {templateData.components.footer.text && (
                                                <div className="meta-mobile-template-footer">{templateData.components.footer.text}</div>
                                            )}

                                            {/* Buttons */}
                                            {templateData.components.buttons.length > 0 && (
                                                <div className="meta-mobile-template-buttons">
                                                    {templateData.components.buttons.map((btn, i) => (
                                                        <div key={i} className="meta-mobile-template-button">
                                                            {btn.type === 'QUICK_REPLY' && <button className="meta-mobile-quick-reply">{btn.text}</button>}
                                                            {btn.type === 'URL' && <div className="meta-mobile-url-button"><MDBIcon icon="external-link-alt" /><span>{btn.text}</span></div>}
                                                            {btn.type === 'PHONE_NUMBER' && <button className="meta-mobile-phone-button"><MDBIcon icon="phone-alt" /><span>{btn.text}</span></button>}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateWhatsAppTemplate;